//import { Badge } from "react-bootstrap"
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import './filter-pills-selected-values.component.scss';
export const FilterPillsSelectedValuesComponent = ({
  filterSelection,
}: {
  filterSelection: FilterSelectedValue[];
}) => {
  return (
    <>
      {filterSelection.map((f) => (
        <span key={f.id} className="badge-container">
          {f.values?.map((v, index) => (
            // <div className="filter-pill">
            <div
              className={`badge-wrapper ${v.exclude ? 'exclude' : ''}`}
              key={index}
            >
              {/* <span className={`badge-link ${v.exclude ? 'exclude' : 'include'}`}>
                                <div>{v.exclude ? 'Exclude' : 'Include'}</div>
                            </span> */}
              <div className="badge-description">
                <div>{v.label}</div>
              </div>
            </div>

            // </div>

            //  <Badge key={index} bg={f.matchStrategy?.valueMatch === VALUE_MATCH.EXCLUDE_MULTIPLE ? 'secondary' : 'primary'}>{v.label}</Badge>
          ))}
        </span>
      ))}
    </>
  );
};
